import React, { Component } from 'react';

import PropTypes from 'prop-types';

// Graphql
import { graphql, useQuery } from 'react-apollo';
import gql from 'graphql-tag';

// React Table
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import matchSorter from 'match-sorter';

// Material UI Imports
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Tooltip from '@material-ui/core/Tooltip';

// Material Icons Imports
import IconContentAdd from '@material-ui/icons/AddCircle';
import IconSaveAlt from '@material-ui/icons/FileCopy';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline'
import green from '@material-ui/core/colors/green';
import CancelOutlined from '@material-ui/icons/CancelOutlined'
import IconBack from '@material-ui/icons/ArrowBack';
import IconEdit from '@material-ui/icons/Edit';
import IconMail from '@material-ui/icons/Mail'

//Components imports
import NormalField from './innerComponents/NormalField';
import UserDetail from './UserDetail';
import CustomLoader from './innerComponents/CustomLoader';

import { Link } from 'react-router-dom';

// Assets imports
import '../styles/ReactTable.css';
import '../styles/UsersList.css';
import { compose } from 'recompose';

// Lodash
import _ from 'lodash';

// Select
import Select from "react-select";

import axios from 'axios';
import moment from 'moment';
import CertificateTableActions from './innerComponents/CertificateTableActions';
import CertificationsTableActions from './innerComponents/CertificationsTableActions';

import { Parser } from 'json2csv'

const styles = {
    paperStyle: {
        // General styles for paper
        width: "60%",
        margin: "0 auto",
        height: "auto",
    },
    checkCircleOutline: {
        color: green[500]
    },
    cell: {
        margin: 'auto'
    },
    iconButton: {
        marginRight: 8
    },
    certificationContainer: {
        width: "50%",
        padding: "16px",
    },
    extraTitle: {
        opacity: "0.8",
        fontSize: "20px",
    }
}

function ExpiryDateFilter({filter, onChange}) {
  return (
    <select
      onChange={event => onChange(event.target.value)}
      style={{ width: "100%" }}
      value={filter ? filter.value : '0'}>
        <option value="0">All</option>
        <option value="1">Expired</option>
        <option value="2">Due To Expire</option>
        <option value="3">Active</option>
    </select>
  );
}

class CertificatesList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            showTraining: true,
            showDetail: false,
            showCertificationDetail: false,
            selectedId: "1",
            selectedCertificationId: "1",
            selectedName: null,
            selectedCertificationName: null,
            expiryDate: new Date(),
            refetchDetail: false,
            exportToCSVUserAndCertificatesButton: true,
            exportToCSVCertificatesButton: true,
            exportToCSVCertificationsButton: true,
            certificatesData: [],
            selectedCertification: null,
            allCertificatesFilters: [],
            userCertFilters: [],
        };
    }

    handleTabChange = (event, value) => {
        this.setState({ value });
    };

    async _handleBackClick() {
        await this.props.all_users_query.refetch()
            .then(this.props.all_certificates_query.refetch())
            .then(this.setState({
                showTraining: !this.state.showTraining,
                showDetail: !this.state.showDetail,
                refetchDetail: false
            }))
            ;
    }

    async _handleCertificationBackClick() {
        await this.props.all_users_query.refetch()
            .then(this.props.all_certifications_query.refetch())
            .then(this.setState({
                showTraining: !this.state.showTraining,
                showCertificationDetail: !this.state.showCertificationDetail,
                refetchDetail: false
            }))
            ;
    }

    handleUserClick(info) {
        this.setState({
            selectedId: info.original.id,
            selectedName: info.row.fullName,
            showTraining: !this.state.showTraining,
            showDetail: !this.state.showDetail
        });
    }

    handleCertificationClick(info) {
        this.setState({
            selectedCertificationId: info.original.id,
            selectedCertificationName: info.row.name,
            showTraining: !this.state.showTraining,
            showCertificationDetail: !this.state.showCertificationDetail
        });
    }

    componentDidMount() {
        if (this.props.location.state) {
            if (this.props.location.state.tab) {
                this.setState({ value: this.props.location.state.tab })
            }
            if (this.props.location.state.refetch === true) {
                this.props.all_certificates_query.refetch()
                    .then(this.props.all_users_query.refetch())
                    .then(this.props.all_certifications_query.refetch())
                    .then(() => {
                        this.setState({
                            refetchDetail: true
                        })
                    })
            }
        }
    }

    handleCreateClick(to) {
        this.props.history.push({
            pathname: `/${to}/new`,
            state: {
                tab: this.state.value
            }
        })
    }

    handleExportToCSV(table) {
        const date = moment(new Date()).format('YYYY_MM_DD-HH_mm_a')
        let tableReference;
        let report_name;
        switch (table) {
            case 'user_and_certificates':
                tableReference = this.usersAndCertificatesReactTable;
                report_name = `rhodar_users_and_certificates_report-${date}`
                break;
            case 'certificates':
                tableReference = this.certificatesReactTable;
                report_name = `rhodar_certificates_report-${date}`

                if (this.state.selectedCertification != null) {
                    let certificationName = this.state.selectedCertification.label.replace(/\s/g,'');
                    report_name = `rhodar_missing_${certificationName}_certification_report-${date}`;
                }

                break;
            case 'certifications':
                tableReference = this.certificationsReactTable;
                report_name = `rhodar_certifications_report-${date}`
                break;
            default:
                return;
        }

        let tableData = tableReference.getResolvedState().sortedData.map(data => {
            return _.omitBy(data, (value, key) => {
                return _.startsWith(key, '_')
            });
        }).map(data => {
            if (this.state.selectedCertification === null ) {
                if (data.closestExpiringCerticateDate) {
                    const closestExpiringCerticateDate = moment(data.closestExpiringCerticateDate).format('YYYY-MM-DD')
                    data.closestExpiringCerticateDate = closestExpiringCerticateDate
                }
                data.expiryDate = moment(data.expiryDate).format('YYYY-MM-DD')
            } else {
                data.id = parseInt(data.id);
            }
            return data;
        })

        if (tableData[0]) {
            const fields = Object.keys(tableData[0]).filter(key => key != "actions");
            const json2csvParser = new Parser({ fields });
            const csv = json2csvParser.parse(tableData);
            const url = window.URL.createObjectURL(new Blob([csv],
                { type: 'text/csv' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${report_name}.csv`);
            document.body.appendChild(link);
            link.click()
        }
    }

    handleArchive() {
        this.props.all_users_query.refetch()
            .then(this.props.all_certificates_query.refetch())
            .then(this.setState({
                refetchDetail: true
            }));
    }

    handleCertificationArchive() {
        this.props.all_users_query.refetch()
            .then(this.props.all_certifications_query.refetch())
            .then(this.setState({
                refetchDetail: true
            }));
    }

    handleExpiryDateStatusFilterChange = (filter, row) => {
        if(filter.value === '0')
            return true;

        if(filter.value === '1')
            return row[filter.id] === 'Expired';

        if(filter.value === '2')
            return row[filter.id] === 'Due To Expire';

        if(filter.value === '3')
            return row[filter.id] === 'Active';
    }

    handleOnSendEmail = () => {
        var apiBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL + "/certificates/send_certificates_email";

        axios.post(
            apiBaseUrl,
            {region_id: null},
            {headers: {'Authorization': localStorage.getItem("token")}}
        ).then((response)=>{
            alert(response.data.msg)
        }).catch((error) => {
            console.log(error);
        });
    }

    handleCertificationChange = async (certification) => {
        if (certification) {
            this.props.all_users_without_certificate_query.refetch({id: certification.value}).then((res) => {
                if (res.data.usersWithoutCertificate) {
                    const users_without_certificate_list = res.data.usersWithoutCertificate.map(user => {
                        if (user.region.name)
                            user.region = user.region.name;
                        return user;
                    });
                    const users_without_certificate_ordered_list = _.orderBy(users_without_certificate_list, ['region', 'fullName'], ['asc','asc']);
                    this.setState(
                        {
                            certificatesData: users_without_certificate_ordered_list,
                            exportToCSVCertificatesButton: users_without_certificate_ordered_list.length <= 0,
                            selectedCertification: certification,
                        });
                }
            });
        } else {
            this.setState({certificatesData: [], selectedCertification: null, allCertificatesFilters: []});
        }
    }

    handleCertificatesTableData(data) {
        let tableData = {};

        tableData.columns = data.certificatesColumns;
        tableData.data = data.all_certificates;

        if (data.selectedCertification != null) {
            tableData.columns = data.usersWithoutCertificateColumns;
            tableData.data = data.certificatesData;
        }

        return tableData;
    }

    render() {

        const { classes } = this.props;
        const currentUserId = localStorage.getItem('current_user')
        var adminsWhiteList = process.env.REACT_APP_CHANGE_PASSWORD_ADMIN_WHITELIST.split(',');

        // Check if the query response is being loaded
        if (this.props.all_certificates_query && this.props.all_certificates_query.loading) {
            return <CustomLoader label={'Loading certificates'}/>
        }
        // Check if the query response is being loaded
        if (this.props.all_certifications_query && this.props.all_certifications_query.loading) {
            return <CustomLoader label={'Loading certifications'}/>
        }

        // Check if there were errrors
        if (this.props.all_certificates_query && this.props.all_certificates_query.error) {
            console.log(this.props.all_certificates_query);
            return <div>Error loading certificates</div>
        }
        if (this.props.all_certifications_query && this.props.all_certifications_query.error) {
            return <div>Error loading certifications</div>
        }

        if (this.props.all_users_query && this.props.all_users_query.loading) {
            return <CustomLoader label={'Loading'}/>
        }

        // Check if there were errrors
        if (this.props.all_users_query && this.props.all_users_query.error) {
            return <div>Error</div>
        }

        // Check if the query response is being loaded
        if (this.props.all_users_without_certificate_query && this.props.all_users_without_certificate_query.loading) {
            return <CustomLoader label={'Loading users with missing certifications'}/>
        }

        // Check if the query response is being loaded
        if (this.props.all_users_without_certificate_query && this.props.all_users_without_certificate_query.error) {
            return <div>Error loading users with missing certifications</div>
        }

        const all_user_certificates = this.props.all_certificates_query.certificates;

        const active_users_certificates = _.filter(all_user_certificates, (certificate, key) => {
            return certificate.user.active
        })

        const certificates_id_int = active_users_certificates.map(certificate => {
            let diff = moment(certificate.expiryDate).diff(moment(), 'days');
            certificate.expiryDateStatus = 'Active';
            if (moment().isAfter(certificate.expiryDate) || diff == 0) {
                certificate.expiryDateStatus = 'Expired';
            } else if (diff >=1 && diff <= 30) {
                certificate.expiryDateStatus = 'Due To Expire';
            }

            certificate.id = parseInt(certificate.id, 10);

            return certificate;
        })

        const certifications_id_int = this.props.all_certifications_query.certifications.map(certification => {
            certification.id = parseInt(certification.id, 10)
            return certification
        })

        const all_certifications = _.orderBy(certifications_id_int, 'id', 'asc');
        // const totalRequiredCertifications = _.filter(all_certifications, c => c.required);

        const users_with_certificates_info = this.props.all_users_query.users.map(user => {
            const closestCertificate = _.minBy(user.certificates, function (c) {
                const date = new Date(c.expiryDate);
                return date.getTime();
            });
            // const activeCertifications = _.uniq(user.certificates.map(certificate => {
            //     return certificate.certification;
            // }));
            // const requiredCertificationsActive = _.filter(activeCertifications, certification => certification.required);

            // user.missingRequired = _.differenceWith(totalRequiredCertifications, requiredCertificationsActive, (a, b) => a.name === b.name);
            // user.allRequiredCertifications = requiredCertificationsActive.length === totalRequiredCertifications.length;
            user.closestExpiringCerticate = closestCertificate ? closestCertificate : null;
            return user;
        })

        const all_users = _.orderBy(users_with_certificates_info, ['fullName', 'closestExpiringCerticate.expiryDate'], ['asc', 'asc']);

        const all_certificates = _.orderBy(certificates_id_int, ['user.fullName', 'expiryDate'], ['asc']);

        const certificationOptions = all_certifications.map(certification => ({
            value: certification.id,
            label: certification.name
        }))

        const { value, certificatesData, selectedCertification } = this.state;

        const certificatesColumns = [
            {
                Header: 'Id',
                accessor: 'id',
                filterable: false,
                maxWidth: 100

            },
            {
                Header: 'User',
                id: "userFullName",
                accessor: d => d.user.fullName,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["userFullName"] }),
                filterAll: true
            }, {
                Header: 'Role',
                id: "role",
                accessor: d => d.user.role,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["role"] }),
                filterAll: true
            }, {
                Header: 'Region',
                id: "region",
                accessor: d => d.user.region.name,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["region"] }),
                filterAll: true,
                maxWidth: 80
            }, {
                Header: 'Expiry Date',
                id: 'expiryDate',
                accessor: d => (new Date(d.expiryDate)),
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: [item => moment(item.expiryDate).format('YYYY-MM-DD')] }),
                filterAll: true,
                Cell: c => {
                    return (<span>{moment(c.original.expiryDate).format('YYYY-MM-DD')}</span>)
                }
            }, {
                Header: 'Certification',
                id: 'certificationName',
                accessor: d => d.certification.name,
                filterMethod: (filter, rows) =>
                    _.filter(rows, row => _.includes(row['certificationName'].toLowerCase(), filter.value.toLowerCase())),
                filterAll: true
            },
            {
                Header: 'Status',
                id: 'expiryDateStatus',
                accessor: d => {return d.expiryDateStatus},
                filterMethod: (filter, row) => {
                    return this.handleExpiryDateStatusFilterChange(filter, row);
                },
                Filter: ExpiryDateFilter,
                Cell: c => {
                    let style = {color: '#FF0000'}
                    if (c.original.expiryDateStatus === 'Due To Expire')
                        style = {color: '#e79c2a'}
                    if (c.original.expiryDateStatus === 'Active')
                        style = {color: '#16817a'}

                    return (<span style={style}>{c.original.expiryDateStatus}</span>)
                }
            }, {
                Header: 'Actions',
                id: 'actions',
                filterable: false,
                sortable: false,
                Cell: c => <div className={classes.cell}><CertificateTableActions handler={this.handleArchive.bind(this)} certificate={c.original} /></div>
            }
        ]

        var certificationsColumns = [
            {
                Header: 'Id',
                accessor: 'id',
                filterable: false
            }, {
                Header: 'Name',
                id: 'name',
                accessor: d => d.name,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["name"] }),
                filterAll: true
            }
            // , {
            //     Header: 'Is Required',
            //     id: 'required',
            //     accessor: d => d.required ? 'Yes' : 'No',
            //     filterMethod: (filter, rows) =>
            //         matchSorter(rows, filter.value, { keys: ["required"] }),
            //     filterAll: true
            // }
        ]

        if(adminsWhiteList.includes(currentUserId)){
            certificationsColumns.push({
                Header: 'Actions',
                id: 'actions',
                filterable: false,
                sortable: false,
                Cell: c => <div className={classes.cell}><CertificationsTableActions handler={this.handleCertificationArchive.bind(this)} certification={c.original} /></div>
            })
        }

        const usersColumns = [
            {
                Header: 'Name',
                id: "fullName",
                accessor: d => d.fullName,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["fullName"] }),
                filterAll: true
            }, {
                Header: 'Email',
                accessor: 'email',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["email"] }),
                filterAll: true,
                minWidth: 150
            }, {
                Header: 'Role',
                accessor: 'role',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["role"] }),
                filterAll: true,
                maxWidth: 80
            },
            {
                Header: 'Region',
                id: "region",
                accessor: d => d.region.name,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["region"] }),
                filterAll: true,
                maxWidth: 80
            },
            {
                Header: 'Active Certificates',
                id: 'certificates',
                accessor: d => d.certificates.length,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ['certificates'] }),
                filterAll: true,
                maxWidth: 120,
                Cell: c => <div className={classes.cell}>{c.value} </div>
            },
            {
                Header: 'Expired Certificates',
                id: 'expiredCertificates',
                accessor: d => d.expiredCertificates.length,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ['expiredCertificates'] }),
                filterAll: true,
                maxWidth: 120,
                Cell: c => {
                    const expiredCertificates = c.original.expiredCertificates.map((c) => c.certification.name).join(', ')
                    return (<div className={classes.cell}>{<Tooltip title={expiredCertificates}><div>{c.value}</div></Tooltip>}</div>)
                }
            },
            {
                Header: 'Closest Expiry Date',
                id: 'closestExpiringCerticateDate',
                accessor: d => (d.closestExpiringCerticate ? new Date(d.closestExpiringCerticate.expiryDate) : null),
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ['closestExpiringCerticateDate'] }),
                filterAll: true,
                maxWidth: 120,
                Cell: c => {
                    return (<div className={classes.cell}>{c.original.closestExpiringCerticate && <Tooltip title={c.original.closestExpiringCerticate.certification.name}><div>{moment(c.original.closestExpiringCerticate.expiryDate).format('YYYY-MM-DD')}</div></Tooltip>}</div>)
                }
            }
            // ,
            // {
            //     Header: 'Required certifications',
            //     id: 'allRequiredCertifications',
            //     accessor: d => d.allRequiredCertifications ? 'Yes' : 'No',
            //     filterMethod: (filter, rows) =>
            //         matchSorter(rows, filter.value, { keys: ["allRequiredCertifications"] }),
            //     filterAll: true,
            //     Cell: c => {
            //         const missingReq = c.original.missingRequired.map((certification) => certification.name).join(', ')
            //         return (<div className={classes.cell}>{c.original.allRequiredCertifications ? <CheckCircleOutline className={classes.checkCircleOutline} /> : <Tooltip title={missingReq}><CancelOutlined /></Tooltip>}</div>)
            //     }
            // }
        ]

        const usersWithoutCertificateColumns = [
            {
                Header: 'Id',
                accessor: 'id',
                filterable: false
            },
            {
                Header: 'Name',
                id: "fullName",
                accessor: d => d.fullName,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["fullName"] }),
                filterAll: true
            }, {
                Header: 'Email',
                accessor: 'email',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["email"] }),
                filterAll: true,
            }, {
                Header: 'Role',
                accessor: 'role',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["role"] }),
                filterAll: true,
            },
            {
                Header: 'Region',
                id: "region",
                accessor: d => d.region,
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, { keys: ["region"] }),
                filterAll: true,
            },];

        const certificateTableData = this.handleCertificatesTableData(
            {
                selectedCertification,
                all_certificates,
                certificatesData,
                certificatesColumns,
                usersWithoutCertificateColumns,
            }
        );

        let userDetailNode;
        if (this.state.showDetail) {
            userDetailNode =
                <div>
                    <div className="UsersList-detailFooter">
                        <Button variant="contained"
                            color="primary"
                            onClick={this._handleBackClick.bind(this)}
                        ><IconBack className={classes.iconButton} /> Back</Button>
                    </div>
                    <div className="UsersList-header">
                        <div className="UsersList-title">
                            <span>{this.state.selectedName}</span>
                        </div>
                        <div className="NewProject-actions">
                            <Button
                                component={Link}
                                color="primary"
                                to={`/users/${this.state.selectedId}/edit`}
                            ><IconEdit className={classes.iconButton} /> Edit</Button>
                        </div>
                    </div>
                    <div className="UsersList-detailContent">
                        <UserDetail history={this.props.history} selectedId={this.state.selectedId} expiryDate={this.state.expiryDate} refetch={this.state.refetchDetail} />
                    </div>
                    <div className="UsersList-detailFooter">
                        <Button variant="contained"
                            color="primary"
                            onClick={this._handleBackClick.bind(this)}
                        ><IconBack className={classes.iconButton} /> Back</Button>
                    </div>
                </div>;
        }

        let certificationDetailNode;
        if (this.state.showCertificationDetail) {
            certificationDetailNode =
                <div>
                    <div className="UsersList-detailFooter">
                        <Button variant="contained"
                            color="primary"
                            onClick={this._handleCertificationBackClick.bind(this)}
                        ><IconBack className={classes.iconButton} /> Back</Button>
                    </div>
                    <div className="UsersList-header">
                        <div className="UsersList-title">
                            <span>Certification</span>
                        </div>
                        <div className="NewProject-actions">
                            <Button
                                component={Link}
                                color="primary"
                                to={`/certifications/${this.state.selectedCertificationId}/edit`}
                            ><IconEdit className={classes.iconButton} /> Edit</Button>
                        </div>
                    </div>
                    <div className="UsersList-detailContent">
                        <div className="UserDetail">
                            <div>
                                <NormalField label="Name" input={this.state.selectedCertificationName} />
                            </div>
                        </div>
                    </div>
                    <div className="UsersList-detailFooter">
                        <Button variant="contained"
                            color="primary"
                            onClick={this._handleCertificationBackClick.bind(this)}
                        ><IconBack className={classes.iconButton} /> Back</Button>
                    </div>
                </div>;
        }

        let trainingNode;
        if (this.state.showTraining) {
            trainingNode =
                <div>
                    <AppBar position='static'>
                        <Tabs value={value} onChange={this.handleTabChange} fullWidth>
                            <Tab label="Users and Certificates" />
                            <Tab label="All Certificates" />
                            <Tab label="Certifications" />
                        </Tabs>
                    </AppBar>
                    {value === 0 &&
                        <div>
                            <div className="UsersList-header">
                                <div className="UsersList-title">
                                    <span>Users and Certificates List</span>
                                </div>
                                <div className="UsersList-actions">
                                    <Button
                                        color="primary"
                                        to="/certificates/new"
                                        onClick={() => this.handleCreateClick('certificates')}
                                    > <IconContentAdd className={classes.iconButton} />Add Certificate</Button>
                                    <Button
                                        color="primary"
                                        disabled={this.state.exportToCSVUserAndCertificatesButton}
                                        onClick={() => this.handleExportToCSV('user_and_certificates')}
                                    > <IconSaveAlt className={classes.iconButton} />Export to CSV</Button>
                                </div>
                            </div>
                            <div className="UsersList-table">
                                <ReactTable
                                    data={all_users}
                                    ref={(r) => this.usersAndCertificatesReactTable = r}
                                    filterable
                                    columns={usersColumns}
                                    onFetchData={(state, instance) => {
                                        this.setState({ exportToCSVUserAndCertificatesButton: (state.sortedData.length <= 0) })
                                    }}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                    getTdProps={(state, rowInfo, column, instance) => {
                                        const info = rowInfo;
                                        return {
                                            onClick: e => {
                                                this.handleUserClick(info);
                                            }
                                        };
                                    }}
                                    filtered={this.state.userCertFilters}
                                    onFilteredChange={filtered => this.setState({userCertFilters: filtered})}
                                />
                            </div>
                        </div>
                    }
                    {value === 1 &&
                        <div>
                            <div className="UsersList-header">
                                <div className="UsersList-title">
                                    <span>Certificates List</span>
                                </div>
                                <div className="UsersList-actions">
                                    <Button
                                        color="primary"
                                        onClick={() => this.handleCreateClick('certificates')}
                                    > <IconContentAdd className={classes.iconButton} />Add Certificate</Button>
                                    <Button
                                        color="primary"
                                        onClick={() => this.handleExportToCSV('certificates')}
                                        disabled={this.state.exportToCSVCertificatesButton}
                                    > <IconSaveAlt className={classes.iconButton} />Export to CSV</Button>
                                    <Button
                                        color="primary"
                                        onClick={() => this.handleOnSendEmail()}
                                    > <IconMail className={classes.iconButton} />Send Email</Button>
                                </div>
                            </div>
                            <div className="UsersList-header">
                                <div className="UsersList-title">
                                    <span style={styles.extraTitle}>
                                        Extra Filters
                                    </span>
                                </div>
                                <div style={styles.certificationContainer}>
                                    <Select
                                        value={selectedCertification}
                                        options={certificationOptions}
                                        onChange={(e) => {this.handleCertificationChange(e)}}
                                        isClearable={true}
                                        placeholder="Filter By Missing Certification"/>
                                </div>
                            </div>
                            <div className="UsersList-table">
                                <ReactTable
                                    data={certificateTableData.data}
                                    ref={(r) => this.certificatesReactTable = r}
                                    filterable
                                    columns={certificateTableData.columns}
                                    onFetchData={(state, instance) => {
                                        this.setState({ exportToCSVCertificatesButton: (state.sortedData.length <= 0) });
                                    }}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                    filtered={this.state.allCertificatesFilters}
                                    onFilteredChange={filtered => this.setState({allCertificatesFilters: filtered})}
                                />
                            </div>
                        </div>
                    }
                    {
                        value === 2 &&
                        <div>
                            <div className="UsersList-header">
                                <div className="UsersList-title">
                                    <span>Certifications List</span>
                                </div>
                                <div className="UsersList-actions">
                                    <Button
                                        color="primary"
                                        onClick={() => this.handleCreateClick('certifications')}
                                    > <IconContentAdd className={classes.iconButton} />Add Certification</Button>
                                    <Button
                                        color="primary"
                                        onClick={() => this.handleExportToCSV('certifications')}
                                        disabled={this.state.exportToCSVCertificationsButton}
                                    > <IconSaveAlt className={classes.iconButton} />Export to CSV</Button>
                                </div>
                            </div>
                            <div className="UsersList-table">
                                <ReactTable
                                    data={all_certifications}
                                    ref={(r) => this.certificationsReactTable = r}
                                    filterable
                                    onFetchData={(state, instance) => {
                                        this.setState({ exportToCSVCertificationsButton: (state.sortedData.length <= 0) })
                                    }}
                                    getTdProps={(state, rowInfo, column, instance) => {
                                        const info = rowInfo;
                                        return {
                                            onClick: e => {
                                                this.handleCertificationClick(info);
                                            }
                                        };
                                    }}
                                    columns={certificationsColumns}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                                />
                            </div>
                        </div>
                    }

                </div>
        }




        return (
            <Paper className={classes.paperStyle} elevation={1} >
                {trainingNode}
                {userDetailNode}
                {certificationDetailNode}
            </Paper>
        );
    }


}

CertificatesList.propTypes = {
    classes: PropTypes.object.isRequired,
};


// GraphQL Query
const ALL_CERTIFICATES_QUERY = gql`
    query certificates{
        certificates(filters:[{
                field:"marked_as_deleted_eq", operand:"false"}
        ]){
        id
        user{
            id
            role
            fullName
            active
            region{
                name
            }
        }
        expiryDate
        baseFileName
        certification{
        id
        name
        }
    }
    }
`;

const ALL_CERTIFICATIONS_QUERY = gql`
query certifications{
  certifications(filters:[{field:"marked_as_deleted_eq", operand:"false"}]){
    id
    name
  }
}
`;

const ALL_USERS_QUERY = gql`
query users_query($expiryDate:Date!){
  users(filters:[{field:"active_eq", operand:"true"}]) {
    id
    role
    fullName
    email
    region{
      name
    }
    certificates(filters:[{field:"expiry_date_gt", operand:$expiryDate, connector: AND},
    {field:"marked_as_deleted_eq", operand:"false"}
     ]){
      id
      expiryDate
      certification{
        id
        name
      }
      }
      expiredCertificates: certificates(filters:[{field:"expiry_date_lt", operand:$expiryDate, connector: AND},
    {field:"marked_as_deleted_eq", operand:"false"}
     ]){
      id
      expiryDate
      certification{
        id
        name
      }
      }
  }
}
`;

const ALL_USERS_WITHOUT_CERTIFICATE_QUERY = gql`
query users_without_certificate_query($id: Int!) {
  usersWithoutCertificate(id: $id) {
    id
    role
    fullName
    email
    region{
      name
    }
  }
}
`;

// Exporting the query
export default compose(
    graphql(ALL_CERTIFICATES_QUERY, { name: 'all_certificates_query' }),
    graphql(ALL_CERTIFICATIONS_QUERY, { name: 'all_certifications_query' }),
    graphql(ALL_USERS_QUERY, {
        name: 'all_users_query',
        options: {
            variables: {
                expiryDate: new Date()
            }
        }
    }),
    graphql(ALL_USERS_WITHOUT_CERTIFICATE_QUERY, {
        name: 'all_users_without_certificate_query',
        options: {
            variables: {
                id: -1
            }
        }
    }),
    withStyles(styles)
)(CertificatesList);



// WEBPACK FOOTER //
// src/components/CertificatesList.js